// extracted by mini-css-extract-plugin
export default {"container":"offerWall_container__3Uk0i","list":"offerWall_list__5GwiC","item":"offerWall_item__MJJXj","offerWrapper":"offerWall_offerWrapper__ERc50"};